import React, { useState, useRef, useEffect, useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Classes from "./ProfileDropDown.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../../../redux-store";
import { ArrowDownIcon } from "../../../../utils/Icons";
import backend from "../../../../api";

const sampleProfile = "/assets/images/user.webp";
const sampleCompany = "/assets/images/logo.png";

export default function ProfileDropDown() {
  const { user } = useSelector((state) => state.auth);
  const companyId = user?.companyId;

  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const [dropDown, setdropDown] = useState(false);
  const [company, setCompany] = useState(null);
  const dropdownRef = useRef(null);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setdropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch onboarding company data
  useEffect(() => {
    if (!companyId) return;
    (async () => {
      try {
        const res = await backend.get(`/api/onboarding/${companyId}`);
        const data = res?.data?.data || res?.data;
        if (data) setCompany(data);
      } catch (err) {
        console.warn("Failed to load company info:", err?.response?.data || err.message);
      }
    })();
  }, [companyId]);

  const handleNavigate = (page) => {
    setdropDown(false);
    navigateTo(page);
  };

  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    await dispatch(authActions.logout());
  };

  // Derived display fields
  const userFullName = useMemo(() => {
    if (user?.firstName || user?.lastName)
      return `${user.firstName || ""} ${user.lastName || ""}`.trim();
    return user?.name || "User";
  }, [user]);

  const companyName = company?.companyName || "Your Company";
  const companyLogo = company?.logo || sampleCompany;
  const avatarImg = company?.logo || user?.imageURL || sampleProfile;

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      {/* Avatar Button */}
      <div className="flexAlign10 pointer mr10" onClick={() => setdropDown(!dropDown)}>
        <div className={Classes.card_img}>
          <img
            src={avatarImg}
            className={Classes.card_inner_img}
            alt="profile avatar"
            draggable={false}
          />
        </div>
        <ArrowDownIcon height={10} fill="#747474" />
      </div>

      {/* Dropdown Body */}
      <AnimatePresence>
        {dropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
            style={{ top: "42px", right: "0", zIndex: "11" }}
          >
            <div className={Classes.dropDownBodyInner}>
              {/* HEADER */}
              <div className={Classes.profileHeader}>
                <div className={Classes.card_img2}>
                  <img
                    src={companyLogo}
                    className={Classes.card_inner_img}
                    alt="company logo"
                    draggable={false}
                  />
                </div>
                <div className={Classes.headerTxt}>
                  {/* <h4 title={companyName}>{companyName}</h4> */}
                  <h5>{userFullName}</h5>
                  
                  <h5 className={Classes.miniEmail}>
                    {user?.email || "—"}
                  </h5>
                </div>
              </div>

              <div className={Classes.dropDownLine}></div>

              {/* SETTINGS */}
              <div
                className={Classes.dropDownElem}
                onClick={() => handleNavigate("/settings/profile")}
              >
                <h5>Settings</h5>
              </div>

              <div className={Classes.dropDownLine}></div>

              {/* SIGN OUT */}
              <div className={Classes.dropDownElem} onClick={handleLogout}>
                <h5>Sign Out</h5>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Hidden input for accessibility */}
      <input type="hidden" aria-label="Without label" readOnly />
    </div>
  );
}
